import doc                                      from '@widesk-core/decorators/doc';
import model                                    from '@widesk-core/decorators/model';
import NetworkServiceModel                      from '@/models/NetworkServiceModel';
import RelationRequestTargetResponseModel       from './RelationRequestTargetResponseModel';
import RelationRequestTargetResponseStatusModel from './RelationRequestTargetResponseStatusModel';

@model.urnResource('relation_request_target_response_status_history')
@doc.path('/relation_request_target_response_status_histories/{?id}')
export default class RelationRequestTargetResponseStatusHistoryModel extends NetworkServiceModel {
	@doc.model(RelationRequestTargetResponseModel) declare relationRequestTargetResponse: RelationRequestTargetResponseModel;
	@doc.model(RelationRequestTargetResponseStatusModel) declare relationRequestTargetResponseStatus: RelationRequestTargetResponseStatusModel;
}